import moment from 'moment';
import { Row } from 'react-bootstrap';
import { FaClock, FaFileInvoice, FaMobileAlt, FaUserMd, FaHandHoldingUsd, FaPauseCircle, FaExclamationTriangle, FaPhone } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import paths from 'routes/paths';

const iconMap = {
  due: <FaClock className="me-1" />,
  billing: <FaFileInvoice className="me-1" />,
  mobile: <FaMobileAlt className="me-1" />,
  pa: <FaUserMd className="me-1" />,
  loan: <FaHandHoldingUsd className="me-1" />,
  hold: <FaPauseCircle className="me-1" />,
  is_pharmacy_attention: <FaExclamationTriangle className="me-1" />,
  is_callback : <FaPhone className="me-1" />,
};

const labels = {
  due: 'Due',// is_notified == 1
  billing: 'Billing',//is_billing_issue == 0
  mobile: 'Mobile', //order_status == 1
  pa: 'PA',//is_pa == 1
  loan: 'Loan',// is_loansupplies == 1
  hold: 'Hold', //is_hold == 1
  is_pharmacy_attention: 'Pharmacy Attention',//is_pharmacy_attention == 1
  is_callback : 'Call Back',//is_callback == 1
};

const TopSummaryBar = ({ stats, orderStatusToDate, orderStatusFromDate }) => {
  const navigate = useNavigate();
  const patientDetails = paths.orderDetail;
  const hold = paths.indexHold;

  const handleClick = (e) => {
    const params = new URLSearchParams();
    const holdParams = new URLSearchParams();
    holdParams.append('id', e);
    params.append('id', e);
    const today = moment().format('MM/DD/YYYY');           // today
    const oneMonthAgo = moment().subtract(1, 'months').format('MM/DD/YYYY'); // 1 month before
    params.append('to', today);
    params.append('from', oneMonthAgo);
    holdParams.append('to', today);
    holdParams.append('from', oneMonthAgo);
    navigate(`${e != 'hold' ? patientDetails : hold}?${e != 'hold' ? params.toString() : holdParams.toString()}`);
  };
  return (
    <Row className="mb-3 px-3">
      <div className="d-flex flex-wrap gap-3 justify-content-center">
        {Object.entries(stats).map(([key, value]) => (
          <div
            key={key}
            className="d-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
            style={{
              backgroundColor: 'var(--bs-body-bg)',
              border: '1px solid var(--bs-border-color)',
              color: 'var(--bs-body-color)',
              fontWeight: 500,
              minWidth: 110,
              fontSize: 14,
              cursor: 'pointer'
            }}
            onClick={() => handleClick(key)}
          >
            {iconMap[key]}
            {labels[key]} <span className="ms-1 text-danger">({value})</span>
          </div>
        ))}
      </div>
    </Row>
  );
};

export default TopSummaryBar;
